import { visionURL } from "../config/environment";
import { fetch } from "whatwg-fetch";
import visionCallService from "./visionCallService";

export const pollForCompletion = courseIds => {
  return fetch(`${visionURL}/learning_center/api/completions`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify({ course_ids: courseIds })
  })
    .then(response => {
      visionCallService.redirectForAuth(response);
      return response.json();
    })
    .then(function(response) {
      return response;
    })
    .catch(function(error) {
      console.log("request failed", error);
    });
};

export const updateUserSettings = (userId, params) => {
  return fetch(`${visionURL}/learning_center/api/users/${userId}`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ user: params })
  })
    .then(response => {
      visionCallService.redirectForAuth(response);
      return response.json();
    })
    .then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      console.log("request failed", error);
    });
};
